import { drawZeroStatistics, calculateExtraStatisticsFields } from './utils'
import _ from 'lodash'

export default class DividedByProvider {
  constructor(statistics, providerName) {
    this.statistics = statistics
    this.providerName = providerName
  }

  calculate() {
    let statistic = _.find(this.statistics, { providerName: this.providerName })

    if (!statistic) return [drawZeroStatistics()]

    const { spent, impressions, clicks, counterImpressions, goals } = statistic

    const processesSpent = _.isNull(spent) ? 0 : parseFloat(spent)
    const processesGoals = goals
      ? _(goals)
          .flatten()
          .sum()
      : 0

    return [
      calculateExtraStatisticsFields({
        providerName: this.providerName,
        impressions,
        counterImpressions,
        clicks,
        spent: processesSpent,
        goals: processesGoals
      })
    ]
  }
}
